import { Button, Col, Icon, Row, Modal, Input } from 'antd';
import { withRouter } from 'react-router';
import { Permission } from 'components/page/index';
import { StyledSelect } from 'components/ui/index';
import PERMISSIONS from 'config/app-permission.config';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Enums from 'utils/EnumsManager';
import { mapToAPIOrderStr } from 'utils/common';
import { getSorter } from '../flow/utils';
import { setActiveView, tryFetchDataByView, tryFetchViewsByType, tryFetchViewsFieldsByType } from '../flow/actions';
import { isLoadFetchUserAndFetchViewId } from '../../../components/page/ObjectFilter/flow/actions';
import { setViewName } from '../../../components/page/ObjectFilter/components/ViewName/flow/actions';
import { setRouteInfo } from '../../../components/page/TaskDetails/flow/actions';
import ModalForm from './ModalForm';

const { PhantomId, ObjectTypes, ObjectTypesInArray } = Enums;
const { Leads } = ObjectTypes;

class Topbar extends Component {
  state = {
    visible: false,
    searchKey: '',
  }

  componentDidMount() {
    const { objectType } = this.props;
    this.props.tryFetchViewsByType(objectType);
  }

  onSearch = () => {
    const {
      objectType,
      PageSizeValue,
      sorters,
      activeViewId,
      routeInfo,
    } = this.props;
    const viewId = _.isEmpty(routeInfo) ? activeViewId[objectType] : PhantomId;
    const sorterInfo = getSorter(viewId, sorters, objectType);

    this.props.tryFetchDataByView(
      objectType,
      viewId,
      {
        page: 1,
        per_page: PageSizeValue,
        search: this.state.searchKey,
        orderBy: sorterInfo.orderBy,
        sortedBy: mapToAPIOrderStr(sorterInfo.sortedBy),
      },
    );
  }

  onChangeSearchKey = (e) => {
    this.setState({ searchKey: e.target.value });
  }

  onChangeView = (value) => {
    const {
      objectType,
      PageSizeValue,
      sorters,
    } = this.props;
    this.props.setActiveView(value, objectType);
    // change view will reset table params
    const sorterInfo = getSorter(value, sorters, objectType);
    this.props.tryFetchDataByView(
      objectType,
      value,
      {
        page: 1,
        per_page: PageSizeValue,
        orderBy: sorterInfo.orderBy,
        sortedBy: mapToAPIOrderStr(sorterInfo.sortedBy),
      },
    );
    this.props.setRouteInfo('');
  }

  onCloseNewViewModal = () => {
    this.setState({ visible: false });
    this.form.resetFields();
  }

  onOpenNewViewModal = () => {
    this.setState({ visible: true });
  }

  onDeleteSearchKey = () => {
    this.setState({ searchKey: '' }, this.onSearch);
  }

  onSaveAndNext = () => {
    const {
      history,
      objectType,
    } = this.props;
    this.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        const { copyViewId, name } = values;
        history.push(`/${objectType}/views/${PhantomId}`);
        await this.props.isLoadFetchUserAndFetchViewId(copyViewId === 'none' ? PhantomId : copyViewId, objectType);
        await this.props.setViewName(name);
        if (copyViewId === PhantomId) {
          this.props.tryFetchViewsFieldsByType(objectType);
        }
      }
    });
  }

  render() {
    const {
      intl,
      activeViewId,
      objectType,
      views,
      routeInfo,
    } = this.props;
    const { formatMessage } = intl;
    const i18n = 'global.ui';
    const viewId = _.isEmpty(routeInfo) ? activeViewId[objectType] : PhantomId;
    const view = views.find(v => v.id === viewId);

    return (
      <Row className="mt-sm mb-sm">
        <Col sm={10}>
          <StyledSelect
            displayField="view_name"
            labelText={formatMessage({ id: `${i18n}.select.label` })}
            options={views}
            onChange={this.onChangeView}
            value={viewId}
          />
          {view && !view.is_created_by_me && !_.isEmpty(view.created_by_user) &&
            <span className="ml-lg" style={{ fontWeight: 'bold' }}>
              {formatMessage({ id: 'page.objectList.sharedBy' })}: {view.created_by_user.name}
            </span>
          }
        </Col>
        <Col sm={4} style={{ textAlign: 'center' }}>
          <Input
            value={this.state.searchKey}
            size="small"
            onChange={this.onChangeSearchKey}
            onPressEnter={this.onSearch}
            suffix={_.isEmpty(this.state.searchKey)
              ? <Icon type="search" />
              : <Icon type="close-circle" onClick={this.onDeleteSearchKey} />
            }
            placeholder={formatMessage({ id: 'page.objectList.searchPlaceHolder' })}
          />
        </Col>
        <Col sm={10} style={{ textAlign: 'right' }}>
          {view && view.is_created_by_me && (
          <Permission permission={PERMISSIONS[`${objectType.toUpperCase()}_EDITVIEWLIST`]}>
            <Link to={`/${objectType}/views/${activeViewId[objectType]}`}>
              <Button className="mr-sm" size="small" disabled={viewId === PhantomId} >
                <Icon className="font-sm" type="edit" size="small" />
                {formatMessage({ id: `${i18n}.button.edit` })}
                {formatMessage({ id: 'global.properNouns.view' })}
              </Button>
            </Link>
          </Permission>
        )}
          <Permission permission={PERMISSIONS[`${objectType.toUpperCase()}_CREATEVIEWLIST`]}>
            <Button
              size="small"
              onClick={this.onOpenNewViewModal}
            >
              <Icon className="font-sm" type="plus" size="small" />
              {formatMessage({ id: `${i18n}.button.new` })}
              {formatMessage({ id: 'global.properNouns.view' })}
            </Button>
            <Modal
              title={`${formatMessage({ id: `${i18n}.button.new` })}${formatMessage({ id: 'global.properNouns.view' })}`}
              visible={this.state.visible}
              onCancel={this.onCloseNewViewModal}
              footer={[
                <Button key="save" size="small" type="danger" onClick={this.onSaveAndNext}> {formatMessage({ id: 'page.layouts.saveAndNext' })}
                </Button>,
                ]}
            >
              <ModalForm
                views={views}
                ref={(c) => { this.form = c; }}
              />
            </Modal>
          </Permission>
        </Col>
      </Row>
    );
  }
}

Topbar.defaultProps = {
  activeViewId: PhantomId,
  objectType: Leads,
  views: [],
  intl: {},
};

Topbar.propTypes = {
  intl: intlShape,
  activeViewId: PropTypes.shape({
    [PropTypes.oneOf(ObjectTypesInArray)]: PropTypes.string,
  }),
  objectType: PropTypes.oneOf(ObjectTypesInArray),
  setActiveView: PropTypes.func.isRequired,
  tryFetchViewsByType: PropTypes.func.isRequired,
  views: PropTypes.array,
  sorters: PropTypes.object.isRequired,
};

const mapStateToProps = ({ global, objectList, taskDetails }) => ({
  language: global.language,
  activeViewId: objectList.activeViewId,
  PageSizeValue: objectList.PageSizeValue,
  views: objectList.views,
  routeInfo: taskDetails.routeInfo,
  sorters: objectList.sorters,
});

const mapDispatchToProps = {
  setActiveView,
  tryFetchDataByView,
  tryFetchViewsByType,
  setRouteInfo,
  setViewName,
  tryFetchViewsFieldsByType,
  isLoadFetchUserAndFetchViewId
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Topbar)));



// WEBPACK FOOTER //
// ./src/views/ObjectList/components/Topbar.jsx